import NamedDto from 'modules/base/dto/NamedDto';

import UnitOptimizerStateInjectEditDto from './UnitOptimizerStateInjectEditDto';

export class UnitOptimizerEditDto extends NamedDto {
	constructor() {
		super();

		/** @type {number} */
		this.measurement = null;

		/** @type {number} */
		this.optimizationCase = null;

		/** @type {number} */
		this.unitOptimizerLog = null;

		/** @type {UnitOptimizerStateInjectEditDto[]} */
		this.stateInject = null;

		/** @type {number} */
		this.whatIf = null;

		/** @type {number} */
		this.multiplier = null;

		/** @type {string} */
		this.uom = null;

		/** @type {string} */
		this.cumulativeUom = null;

		/** @type {number} */
		this.userGroup = null;
	}

	/**
	 * @typedef {Object} _UnitOptimizerEditDtoProps
	 * @property {number} measurement
	 * @property {number} optimizationCase
	 * @property {number} unitOptimizerLog
	 * @property {number} whatIf
	 * @property {number} multiplier
	 * @property {number} uom
	 * @property {number} cumulativeUom
	 * @property {UnitOptimizerStateInjectEditDto[]} stateInject
	 * @property {number} userGroup	
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _UnitOptimizerEditDtoProps} UnitOptimizerEditDtoProps
	 */
	/**
	 *
	 * @param {UnitOptimizerEditDtoProps} props
	 * @returns {UnitOptimizerEditDto}
	 */

	setup(props) {
		super.setup(props);

		this.measurement = props.measurement;
		this.optimizationCase = props.optimizationCase;
		this.unitOptimizerLog = props.unitOptimizerLog;
		this.whatIf = props.whatIf;
		this.multiplier = props.multiplier;
		this.uom = props.uom;
		this.cumulativeUom = props.cumulativeUom;
		this.stateInject = props.stateInject !== null ? props.stateInject.map(d => new UnitOptimizerStateInjectEditDto().setup(d)) : [];
		this.userGroup = props.userGroup;

		return this;
	}
}

export default UnitOptimizerEditDto;